export default class MetadataHandler {
    constructor(metadata) {
        this.supportedMetadata = null;
        this.setMetadata(metadata);
        this.vue = window.AppKit.getApp();
    }

    /**
     * get metadata
     * @returns {*}
     */
    getMetadata() {
        return this.metadata;
    }

    /**
     * get metadata by id
     * @param id
     * @returns {*}
     */
    getMetadataById(id){
        return this.metadata.find(metadata => metadata.id === id);
    }

    /**
     * Get metadata by id and index
     * @param id
     * @param index
     * @return {*|null}
     */
    getMetadataByIdAndIndex(id, index) {
        const metadata = this.metadata[index];
        return metadata.id === id
                ? metadata
                : null;
    }

    /**
     * Get metadata by Id
     * @param id
     * @returns {*}
     */
    async getSupportedMetadataById(id) {
        const supportedMetaData = await this.getSupportedMetadata();
        return supportedMetaData.find(metadata => metadata.id === id);
    }

    /**
     * Set metadata
     * @param metadata
     */
    setMetadata(metadata) {
        this.metadata = metadata;
    }

    /**
     * Set supported metadata
     * @param metadata
     */
    setSupportedMetadata(supportedMetadata) {
        this.supportedMetadata = supportedMetadata;
    }

    /**
     * Get the meta data form url
     *
     * @param metadataId
     * @param blueprintId
     * @param verticalId
     * @param versionId
     * @return {string}
     */
    getMetadataFormUrl(metadataId, blueprintId, verticalId, versionId) {
        const url = new URL(this.vue.$getSetting('paths.baseBlueprint') + '/metadata/form/' + metadataId);
        return url.toString();
    }

    /**
     * Get the meta data save form url
     *
     * @param metadataId
     * @param blueprintId
     * @param verticalId
     * @param versionId
     * @return {string}
     */
    getSaveMetadataFormUrl(metadataId, blueprintId, verticalId, versionId) {
        const url = new URL(this.vue.$getSetting('paths.baseBlueprint') + '/metadata/form/' + metadataId + '/post');
        return url.toString();
    }

    /**
     * Get all the supported meta data options for a blueprint
     * @param bluerpintId
     * @returns {Promise<[{name: string, description: string, id: string},{name: string, description: string, id: string},{name: string, description: string, id: string}]>}
     */
    async getSupportedMetadata() {
        if(! this.supportedMetadata) {
            const url = await this.vue.$getSetting('paths.baseBlueprint') + '/metadata/supported/';
            this.supportedMetadata = await this.vue.$get(url);
        }
        return this.supportedMetadata;
    }
}